import React from 'react';

import RatesEnvironmentsField from './EnvironmentsField';
import RatesCompanyRates from './CompanyRates';
import RatesFamilyRates from './FamilyRates';
import RatesProductRates from './ProductRates';
import RatesDiscountsSectionHeader from './RatesDiscountsSectionHeader';
import RatesGeneralInfoHeader from './RatesGeneralInfoHeader';

const resolveCurrencyId = (data) => {
    const value = data?.idCurrency;
    if (value && typeof value === 'object') return value.value ?? value.id;
    return data?.idcurrency ?? data?.idCurrency ?? null;
};

export const getRatesCustomFields = ({
    changeField,
    data,
    errors,
    field,
    firstErrorField,
    getError,
    idCurrency,
    idEnvironment,
}) => {
    const resolvedCurrency = idCurrency ?? resolveCurrencyId(data);
    const resolvedEnvironment = idEnvironment ?? data?.strIdEnvironment;

    switch (field.id) {
        case 'ratesGeneralInfoHeader':
            return <RatesGeneralInfoHeader key={field.id} />;
        case 'strIdEnvironment':
            return (
                <RatesEnvironmentsField
                    key={field.id}
                    changeField={changeField}
                    data={data}
                    errors={errors}
                    field={field}
                    firstErrorField={firstErrorField === field.id}
                    getError={getError}
                />
            );
        case 'ratesDiscountsSectionHeader':
            return <RatesDiscountsSectionHeader key={field.id} />;
        case 'familyrates':
            return (
                <RatesFamilyRates
                    key={field.id}
                    changeField={changeField}
                    data={data}
                    errors={errors?.familyrates}
                    field={field.id}
                    idCurrency={resolvedCurrency}
                    idEnvironment={resolvedEnvironment}
                    modelList={data?.familyrates}
                />
            );
        case 'productrates':
            return (
                <RatesProductRates
                    key={field.id}
                    changeField={changeField}
                    currencySymbol={data?.currencysymbol}
                    data={data}
                    errors={errors?.productrates}
                    field={field.id}
                    idCurrency={resolvedCurrency}
                    idEnvironment={resolvedEnvironment}
                    modelList={data?.productrates}
                />
            );
        case 'companyrates':
            return (
                <RatesCompanyRates
                    key={field.id}
                    changeField={changeField}
                    data={data}
                    field={field.id}
                    modelList={data?.companyrates}
                />
            );
        default:
            return null;
    }
};
